import { SVGProps } from '@components/Icon/types';

export const PDP = ({ fill = '#000', size = 24, ...props }: SVGProps) => (
  <svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <g transform="translate(2, 2)">
      <path
        d="M14.2109 9.5C14.5986 9.5 14.8593 9.8188 14.8594 10.1475V12.7852C14.8594 13.1138 14.5987 13.4326 14.2109 13.4326C13.8235 13.4323 13.5635 13.1137 13.5635 12.7852V11.7656L11.1982 14.2471C10.9712 14.485 10.6595 14.623 10.3232 14.623C9.98724 14.6229 9.67613 14.4849 9.44922 14.2471L8.03613 12.7646L6.21777 14.6699C6.09358 14.8017 5.92256 14.871 5.74805 14.8711C5.57142 14.871 5.40207 14.8006 5.27832 14.6709C5.04032 14.4213 5.04038 14.027 5.27832 13.7773L7.16113 11.8027C7.38814 11.5648 7.699 11.4268 8.03516 11.4268L8.16016 11.4336C8.44781 11.4633 8.71058 11.5946 8.90918 11.8027L10.3223 13.2852L12.6982 10.7949H11.6953C11.3077 10.7948 11.0469 10.4761 11.0469 10.1475C11.0469 9.81887 11.3078 9.50014 11.6953 9.5H14.2109Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 0C18.2091 0 20 1.79086 20 4V16C20 18.14 18.3194 19.8879 16.2061 19.9951L16 20H4L3.79395 19.9951C1.7488 19.8913 0.108652 18.2512 0.00488281 16.2061L0 16V4C0 1.79086 1.79086 3.22128e-08 4 0H16ZM1.40039 16C1.40039 17.4359 2.56406 18.5996 4 18.5996H16C17.4359 18.5996 18.5996 17.4359 18.5996 16V6H1.40039V16ZM4 1.40039C2.56406 1.40039 1.40039 2.56406 1.40039 4V4.59961H18.5996V4C18.5996 2.56406 17.4359 1.40039 16 1.40039H4Z"
        fill={fill}
      />
    </g>
  </svg>
);

export const ICON_NAME = 'pdp';
